import React from "react";
import { HeaderClass, Footer } from "../../components";
import styles from "./ConnactUs.module.css";
import { Form, Input, InputNumber, Button } from "antd";
import { useRef, useEffect } from "react";
import { apiPost } from "../../utils/axiosFn";
import { Modal, message, Breadcrumb } from "antd";
import { ExclamationCircleOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";

export const ConnactUs: React.FC = () => {
  const username = useRef<any>(null);
  const phone = useRef<any>(null);
  const email = useRef<any>(null);
  const content = useRef<any>(null);
  const navigate = useNavigate();
  const layout = {
    labelCol: { span: 3 },
    wrapperCol: { span: 10 },
  };
  const validateMessages = {
    required: "${label}是必填的!",
    types: {
      email: "${label} is not a valid email!",
      number: "${label} is not a valid number!",
    },
    number: {
      range: "${label} must be between ${min} and ${max}",
    },
  };
  const onFinish = (values: any) => {
    console.log(values);
  };
  const submitFormTable = () => {
    const data = {
      username: username.current.input.value,
      phone: Number(phone.current.input.value),
      email: email.current.input.value,
      content: content.current.resizableTextArea.textArea.value,
    };

    Modal.confirm({
      title: "提交",
      icon: <ExclamationCircleOutlined />,
      content: "确认提交？",
      okText: "确认",
      cancelText: "取消",
      onOk: async () => {
        try {
          const res = await apiPost("/api/contract/save", data, null, null);

          message.success("保存完成");
          username.current.input.value = "";
          phone.current.input.value = "";
          email.current.input.value = "";
          content.current.resizableTextArea.textArea.value = "";
        } catch (error) {
          alert(error);
        }
      },
    });
  };

  return (
    <>
      <HeaderClass />

      <div className={styles["w"]}>
        <Breadcrumb
          separator=""
          className={styles["Breadcrumb"]}
          style={{
            margin: "-20px 0 20px 90px",
            fontSize: "15px",
            color: "#000",
          }}
        >
          <Breadcrumb.Item>当前位置</Breadcrumb.Item>
          <Breadcrumb.Separator> &nbsp;&nbsp;&nbsp;&nbsp;</Breadcrumb.Separator>
          <Breadcrumb.Item href="" onClick={() => navigate("/")}>
            首页
          </Breadcrumb.Item>
          <Breadcrumb.Separator> &gt; </Breadcrumb.Separator>

          <Breadcrumb.Item href="">在线留言</Breadcrumb.Item>
        </Breadcrumb>
        <span
          style={{
            width: "140px",
            background: "#00508B",
            color: "#fff",
            padding: "7px 25px",
            borderTopLeftRadius: "10px",
            borderTopRightRadius: "10px",
            fontWeight: 500,
            fontSize: "14px",
            marginLeft: "90px",
          }}
        >
          在线留言
        </span>
        <div
          style={{
            margin: "5px 0 40px 90px",
            width: "1080px",
            height: "3px",
            background: "#00508B",
          }}
        ></div>
        <Form
          {...layout}
          name="nest-messages"
          onFinish={onFinish}
          validateMessages={validateMessages}
        >
          <Form.Item
            name={["user", "name"]}
            label="姓名："
            rules={[{ required: true }]}
          >
            <Input className={styles["name"]} ref={username} />
          </Form.Item>
          <Form.Item
            name={["user", "phone"]}
            label="手机号："
            rules={[{ required: true, max: 11 }]}
          >
            <Input className={styles["name"]} ref={phone} />
          </Form.Item>
          <Form.Item
            name={["user", "email"]}
            label="邮箱："
            rules={[{ type: "email", required: true }]}
          >
            <Input className={styles["name"]} ref={email} />
          </Form.Item>

          <Form.Item
            name={["user", "content"]}
            label="内容"
            rules={[{ required: true }]}
          >
            <Input.TextArea className={styles["name"]} ref={content} />
          </Form.Item>
          <Form.Item wrapperCol={{ ...layout.wrapperCol, offset: 7 }}>
            <Button type="primary" htmlType="submit" onClick={submitFormTable}>
              提交
            </Button>
          </Form.Item>
        </Form>
      </div>
      <Footer />
    </>
  );
};
